import { createNamespacedHelpers } from 'vuex'
import { required, minLength, maxLength } from '@corporategiftcom/design-system/validations'
import checkIfStringContainsNotAllowedTag from './checkIfStringContainsNotAllowedTag'

const { mapState } = createNamespacedHelpers('newCampaign')

export default {
  mixins: [checkIfStringContainsNotAllowedTag],
  computed: {
    ...mapState(['alreadyUsedNames', 'loadedCampaignName']),
    campaignNameValidation () {
      const {
        required,
        minLength,
        maxLength,
        isCampaignNameAlreadyUsed,
        isCampaignNameTooShort,
        checkIfStringContainsNotAllowedTag,
      } = this

      return [
        required(),
        minLength({
          min: 2,
          errorMessage: 'Campaign name should have at least 2 characters',
        }),
        maxLength({
          max: 150,
          errorMessage: `You can't create a campaign name with more than 150 characters`,
        }),
        isCampaignNameAlreadyUsed,
        isCampaignNameTooShort,
        checkIfStringContainsNotAllowedTag,
      ]
    }
  },
  methods: {
    required,
    minLength,
    maxLength,
    isCampaignNameAlreadyUsed (val) {
      const { alreadyUsedNames, loadedCampaignName } = this
      if (!val) { return true }

      const trimmedVal = val.trim().toLowerCase()

      // duplicating must not reuse the source campaign's own name; checked locally
      // first so this exact, most common case is caught instantly, without waiting
      // on the async alreadyUsedNames list below
      if (this.$route.query.duplicateFrom && trimmedVal === (loadedCampaignName || '').toLowerCase()) {
        return 'There\'s already a campaign with this name, please change'
      }

      // editing an existing campaign may keep its own current name unchanged
      const isEditingExistingCampaign = this.$route.params.campaignId !== 'create'

      const namesToCheck = isEditingExistingCampaign && loadedCampaignName
        ? alreadyUsedNames.filter((name) => name.toLowerCase() !== loadedCampaignName.toLowerCase())
        : alreadyUsedNames

      return !namesToCheck.some((name) => name.toLowerCase() === trimmedVal)
        || 'There\'s already a campaign with this name, please change'
    },
    isCampaignNameTooShort (val) {
      const parsedVal = val?.trim() || ''
      if (parsedVal.length < 2) { return 'Campaign name should have at least 2 characters' }

      return true
    }
  },
}
